import { type GetAvailableFilterData } from '@clients/TrainApi';

export enum TrainFilters {
    price = 'price',
    time = 'time',
    wagonType = 'wagonType',
    hotel = 'hotel',
    corporation = 'corporation',
}

export interface TrainFilterData extends GetAvailableFilterData {}

export interface TrainFiltersData {
    key: TrainFilters;
    meta: TrainFilterData;
}
